import { initializePushNotifications } from '@/api/push';
// Ordem obrigatória: base comum do Design System e, logo depois, o tema deste app. Nenhum
// componente `Dt*` carrega medida ou cor própria — sem o tema, eles ficam sem estilo.
// `theme-clinica.css` é transcrição literal de Docs/V2/Clinica/clinica/styles.css.
import '@/design-system/tokens/index.css';
import '@/design-system/tokens/theme-clinica.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import './global.css';
import './styles/layout.css';
import { initializeAppInstall } from '@/design-system/composables/useAppInstall';

initializeAppInstall({ storageKey: 'dt-clinica-pwa' });

// Tema salvo pelo próprio app. O protótipo persiste em `dt-cli-theme` a partir do alternador da
// `.hostbar`, que é andaime de demonstração e não foi portado; a chave segue a convenção dos
// demais apps Vue. Cada app é um deployment próprio, então não há colisão entre eles.
const savedTheme = localStorage.getItem('dt_theme');
if (savedTheme === 'light' || savedTheme === 'dark') document.documentElement.dataset['theme'] = savedTheme;

// Deep link tipado de push (`?nrid=<chamadoId>`) — mesmo contrato do Flutter web: o aviso de
// notificação leva direto ao detalhe do chamado, sem passar pelo Início.
const notificationRequestId = new URLSearchParams(window.location.search).get('nrid');
if (notificationRequestId !== null && notificationRequestId !== '') {
  void router.replace(`/manutencoes/${notificationRequestId}`);
}

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount('#app');

// Limpeza direcionada: preserva workers de push e outros registros da origem.
if ('serviceWorker' in navigator) {
  void navigator.serviceWorker.getRegistrations().then(async (registrations) => {
    for (const registration of registrations) {
      const worker = registration.active ?? registration.waiting ?? registration.installing;
      if (worker !== null && /\/(?:flutter_service_worker|sw-cleanup)\.js$/u.test(new URL(worker.scriptURL).pathname)) {
        await registration.unregister();
      }
    }
    for (const key of await caches.keys()) {
      if (key.startsWith('flutter-')) await caches.delete(key);
    }
  }).catch(() => { /* Limpeza legada não impede o acesso ao portal. */ });
}
initializePushNotifications();
